module.exports = __webpack_public_path__ + "img/full4-min.b9787a5b.png";